import { TP_SERVER_DOMAIN } from '../utils/config';
import request from './request';

/** 搜索 swap market 代币
 * @param { String } key - 搜索关键字
 */
export function reqSwapMarketSearch(params, headerData, signal) {
  return request.get(`${TP_SERVER_DOMAIN}/v1/swap_market/search`, 
    { 
      params, 
      headers: headerData,
      signal 
    }
  );
}
/** 获取热门代币列表
 * 
 */
export function reqSwapMarketHotList(headerData) {
  return request.get(`${TP_SERVER_DOMAIN}/v1/swap_market/hot_list`, 
    { 
      headers: headerData 
    }
  );
}